import { render, staticRenderFns } from "./CostMaterialTransportationList.vue?vue&type=template&id=491208da"
import script from "./CostMaterialTransportationList.vue?vue&type=script&lang=js"
export * from "./CostMaterialTransportationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports